export enum ErrorPosition {
  TOP = "top",
  BOTTOM = "bottom",
}
